import React, { useMemo } from "react";
import { Controller } from "react-hook-form";
import { Form, InputNumber, Table } from "antd";

const IndexOrderTableElement = (props) => {
  const { control, fields, errors, applicationIds } = props;

  const dataSource = useMemo(() => {
    let data;
    applicationIds.forEach((element) => {
      let fieldObj = fields.find((field) => field.app_id === element);
      data = fieldObj?.index_order;
    });
    return data;
  }, [applicationIds, fields]);

  const indexOrders = [];

  for (let indexq = 0; indexq < applicationIds?.length; indexq++) {
    indexOrders.push({
      title: fields[indexq]?.app_name,
      dataIndex: fields[indexq]?.app_id,
      key: fields[indexq]?.app_id,
      width: 100,
      render: (_text, _record, indexR) => (
        <Form.Item
          help={
            errors?.index_order?.[indexq]?.index_order?.[indexR]?.order?.message
          }
          validateStatus={
            errors?.index_order?.[indexq]?.index_order?.[indexR]?.order
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`index_order.${indexq}.index_order.${indexR}.order`}
            render={({ field: { onChange, value } }) => (
              <InputNumber
                onChange={(e) => {
                  onChange(e);
                }}
                value={value}
                min={1}
                precision={0}
              />
            )}
          />
        </Form.Item>
      ),
    });
  }

  const columns = [
    {
      title: "Index Name",
      dataIndex: `name`,
      key: `name`,
      width: 100,
    },
  ];

  applicationIds.forEach((appID) => {
    let relevantDefaultIndexOrder = indexOrders.find(
      (indexOrder) => appID === indexOrder.key,
    );
    if (relevantDefaultIndexOrder !== undefined) {
      columns.push(relevantDefaultIndexOrder);
    }
  });

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      rowKey="index_id"
    />
  );
};

export default IndexOrderTableElement;
